import React, {FC} from 'react';
import DeleteIconSrc from 'assets/icons/delete.svg';

import i18n from 'i18next';

type TagProps = {
  label: string;
  onDelete?: () => void;
};

export const TagComponent: FC<TagProps> = props => {
  const stopPropagation = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
  };

  return (
    <div
      className="inline-flex w-auto bg-skyblue text-dodger-blue rounded-huge p-1 pl-2 pr-2 mr-2 mt-2 select-none"
      onClick={stopPropagation}
    >
      <span className="font-medium">{props.label}</span>
      <img
        src={DeleteIconSrc}
        alt={i18n.t('common.remove')}
        width="22px"
        className="cursor-pointer"
        onClick={props.onDelete}
      />
    </div>
  );
};
